import {
  ErrorMessage,
  IsLoading,
  RegisterFormFieldType
} from '../../../../../types';

import { OperationFields } from '../../../operationsTypes';

import { NoTATFormData } from './NoTATForm.types';

import { NoTATFormRecordField } from './components/NoTATFormRecordField';

import { Form } from '../../../../../helpers/Form';
import { InputField } from '../../../../../helpers/FormFields/InputField';
import { DateTimeField } from '../../../../../helpers/FormFields/DateTimeField';
import { ItemsListFieldRequiredProps } from '../../../../../helpers/FormFields/ItemsListField';
import { DropzoneFieldRequiredProps } from '../../../../../helpers/FormFields/DropzoneField';
import { WorkersMultiselectField } from '../../../../users/helpers/WorkersMultiselectField';

import { getDateForTime } from '../../../../../utils/getDateForTime';

import { operationsKeys, words } from '../../../../../locales/keys';
import { LOA_START_HOURS, LOA_END_HOURS } from '../../../operationsConstants';

interface NoTATFormProps {
  form: string;
  isLoading?: IsLoading;
  subjectValidationError?: ErrorMessage;
  bodyValidationError?: ErrorMessage;
  dateValidationError?: ErrorMessage;
  completeDatetimeValidationError?: ErrorMessage;
  registerSubject: RegisterFormFieldType<HTMLInputElement>;
}

function NoTATForm({
  form,
  control,
  isLoading,
  subjectValidationError,
  bodyValidationError,
  dateValidationError,
  completeDatetimeValidationError,
  registerSubject
}: NoTATFormProps &
  ItemsListFieldRequiredProps<NoTATFormData> &
  DropzoneFieldRequiredProps<NoTATFormData>) {
  const loaMinTime = getDateForTime({ hours: LOA_START_HOURS });
  const loaMaxTime = getDateForTime({ hours: LOA_END_HOURS });
  return (
    <Form className="flex-1 overflow-y-auto px-2" id={form}>
      <div className="p-4">
        <div className="space-y-3">
          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <InputField
                disabled
                error={subjectValidationError}
                i18nLabel={operationsKeys.subject}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                name={registerSubject.name}
                onChange={registerSubject.onChange}
                ref={registerSubject.ref}
                type="text"
              />
            </div>
          </div>

          <div>
            <WorkersMultiselectField<NoTATFormData>
              control={control}
              disabled={isLoading}
              name={OperationFields.MENTIONED_USER_IDS}
              i18nLabel={words.notification}
              inputWrapperClassName="mt-1"
              labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
              menuPosition="fixed"
            />
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <NoTATFormRecordField
                disabled={isLoading}
                control={control}
                error={bodyValidationError}
              />
            </div>
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <DateTimeField
                control={control}
                disabled={isLoading}
                error={completeDatetimeValidationError}
                i18nLabel={words.from}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                minTime={loaMinTime}
                maxTime={loaMaxTime}
                name={OperationFields.COMPLETE_DATETIME}
              />
            </div>
          </div>

          <div>
            <div className="w-full sm:w-auto sm:flex-1">
              <DateTimeField
                control={control}
                disabled={isLoading}
                error={dateValidationError}
                i18nLabel={words.to}
                inputWrapperClassName="relative mt-1"
                labelClassName="block text-sm font-medium text-gray-700 dark:text-gray-300"
                minTime={loaMinTime}
                maxTime={loaMaxTime}
                name={OperationFields.DATE}
              />
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
}

export default NoTATForm;
